<template>



    <div>
        <H2>Test</H2>
        <a>{{ $t("titles.front_office") }}</a>
      
    </div>





</template>
<script>
    export default {
        name: "Front_office"
    }
</script>

<style scoped>

</style> 


// WEBPACK FOOTER //
// src/pages/Front_office.vue